export default "__VITE_ASSET__C$ZGOZwP__"